/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2023 - 2023
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useDispatch, useSelector } from "react-redux";

import messages from "../../../helpers/messages";
import {
  refreshCapacityMatches,
  resetBannerActionState,
  setCapacityMatchStatus
} from "../../../slices/bidProcurementSlice";
import {
  status as bidStatus,
  capacityMatchingStatus,
  mode
} from "../../../helpers/types";
import ErrorMessage from "./ErrorMessage";
import SpinnerButton from "./SpinnerButton";
import RefreshIcon from "../../icons/RefreshIcon";

function CarrierRepViewInProgressState({ role, summary }) {
  const dispatch = useDispatch();
  const {
    updateCapacityMatchStatusIsLoading,
    updateCapacityMatchStatusFailure,
    refreshCapacityMatchesIsLoading
  } = useSelector(state => state.bidProcurement);

  const { modes, bidId } = summary;
  const { bidModeId } = modes.find(
    x =>
      x.mode === mode.tl &&
      x.status === bidStatus.inProgress &&
      x.capacityMatchingStatus === capacityMatchingStatus.inProgress
  );

  const handleSendForReview = () => {
    dispatch(resetBannerActionState());
    dispatch(
      setCapacityMatchStatus(
        bidId,
        bidModeId,
        capacityMatchingStatus.review,
        true,
        role
      )
    );
  };

  return (
    <>
      <p className="inline-block font-size-14 pt-16 mb-0">
        {updateCapacityMatchStatusFailure ? (
          <ErrorMessage />
        ) : (
          messages.selectMatchesForTheFollowingLanesBannerMessage.defaultMessage
        )}
      </p>
      <div className="fr py-8 my-2">
        {refreshCapacityMatchesIsLoading ? (
          <SpinnerButton minWidth="150px" />
        ) : (
          <button
            className="text-button univers-67-bold-cond font-size-14 mx-8 h-32 text-transform-none"
            data-testid="refresh-button"
            style={{ minWidth: "150px" }}
            onClick={() => dispatch(refreshCapacityMatches(bidId, role))}
          >
            <RefreshIcon
              className="icon-right align-middle mr-4"
              width="16px"
              height="16px"
              fill="#0066fa"
            />
            {messages.refreshMatches.defaultMessage}
          </button>
        )}
        {updateCapacityMatchStatusIsLoading ? (
          <SpinnerButton minWidth="150px" />
        ) : (
          <button
            className="text-button univers-67-bold-cond font-size-14 mx-8 h-32 border-cobalt-blue"
            data-testid="send-for-review"
            onClick={() => handleSendForReview(bidModeId, bidId)}
            style={{ minWidth: "150px" }}
          >
            {messages.sendForReview.defaultMessage}
          </button>
        )}
      </div>
    </>
  );
}

export default CarrierRepViewInProgressState;
